<template>
    <working-hours :data="data.workingHours" />
</template>

<script setup lang="ts">
import type { FooterItemWorkingHoursFragment } from '@/graphql/api'

import WorkingHours from '@/components/cms/WorkingHours.vue'

defineProps<{
    data: FooterItemWorkingHoursFragment
}>()
</script>
